<script setup lang="ts">
import { PV } from "@/widgets";
import type { defineState } from "../common";

const props = defineProps<{
    state: ReturnType<typeof defineState>;
}>();
</script>

<template>
    <PV.Message v-if="props.state.hasError" class="pl-1" severity="error" size="small" variant="simple">
        {{ props.state.errorMsg }}
    </PV.Message>
</template>
